var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18945 13.6484H14.3314",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2599 2.38886C11.5314 2.11737 11.8996 1.96484 12.2835 1.96484C12.4737 1.96484 12.6619 2.00229 12.8375 2.07504C13.0132 2.14779 13.1728 2.25443 13.3072 2.38886C13.4416 2.52329 13.5483 2.68288 13.621 2.85852C13.6938 3.03416 13.7312 3.22241 13.7312 3.41253C13.7312 3.60264 13.6938 3.79089 13.621 3.96653C13.5483 4.14217 13.4416 4.30176 13.3072 4.43619L4.77665 12.9668L2.04688 13.6492L2.72932 10.9194L11.2599 2.38886Z",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLightIcon);
export default __webpack_public_path__ + "static/media/edit-light-icon.39d8e22490e6b8f14d61899819200bfb.svg";
export { ForwardRef as ReactComponent };